import React from "react";
import MainBidTab from "./Main";
import { BidContextProvider } from "./Bid.context";

export default function BidTab({isEcs=false}) {
  return (
    <BidContextProvider>
      <MainBidTab isEcs={isEcs} />
    </BidContextProvider>
  );
}
